"use client";

import styled from "styled-components";
var BaseSvg = styled.svg.withConfig({
  displayName: "BaseSvg",
  componentId: "sc-yh8lnd-0"
})(["display:inline-block;flex-shrink:0;vertical-align:middle;transition:transform 0.2s ease-out;", ";", ";"], function (props) {
  return "fill: ".concat(props.theme.icons[props.$fillColor] || props.theme.status[props.$fillColor] || props.$fillColor);
}, function (props) {
  return props.rotate && "transform: rotate(".concat(props.rotate, "deg)");
});
export default BaseSvg;